<template>
  <label class="e-checkbox checked">
    <input
      :name="name"
      v-bind:disabled="disabled"
      type="checkbox"
      :class="hasError ? 'checkbox is-invalid' : 'checkbox'"
      v-model="model[name]"
      :value="value"
    >
    <span>{{caption}}</span>
  </label>
</template>

<script>
  export default {
    name: 'e-checkbox',
    data () {
      return {
        error: null
      }
    },
    props: {
      onChangeValidation: {
        type: Boolean,
        default: false
      },
      formValidator: null,
      model: {
        type: Object,
        required: true
      },
      tabView: {
        type: String,
        default: null,
        required: true
      },
      name: {
        type: String,
        default: null,
        required: true
      },
      required: {
        type: Boolean,
        default: false
      },
      modalVariableName: {
        type: String,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: null
      },
      value: {
        type: Boolean,
        default: true
      },
      caption: {
        type: String,
        default: null
      }
    },
    computed: {
      getPlaceholder () {
        if (this.placeholder === null) {
          return ''
        }
        return this.placeholder
      },
      hasError () {
        if (this.error) {
          return true
        }
        return false
      }
    },
    created () {
      if (this.formValidator) {
        this.formValidator.subscribeInput(this)
      }
    },
    methods: {
      change ($event) {
        this.$emit('change', $event)
        if (this.onChangeValidation) {
          this.validate()
        }
      },
      getElement () {
        return this.$refs.element
      },
      validate () {
        let msg = ''
        if (this.required) {
          if (!this.model[this.name]) {
            msg += 'Поставьте галочку. '
          }
        }

        return {
          error: msg,
          tabView: this.tabView,
          name: this.name,
          modalVariableName: this.modalVariableName,
          el: this.getElement()
        }
      }
    }
  }
</script>
